const ChartContainer = ({children, title}) => {
    return (
        <div className="p-1">
            <div className='card border h-100 p-3'>
                {children}
            </div>
        </div>
    )
}

export default ChartContainer;